import { Webview, CookiesType } from "./types";
import Cookies from "js-cookie";

const LEGACY_WEBVIEW_COOKIE = "client";
const WEBVIEW_COOKIE = "client2";

const getWebviewFromCookieValue = (
  cookieValue: string | null,
): Webview | void => {
  if (
    cookieValue === "iphone" ||
    cookieValue === "ipad" ||
    cookieValue === "android" ||
    cookieValue === "outdated_app"
  ) {
    return { isWebview: true, client: cookieValue };
  }
};

export const createWebview = ({
  queryParam,
  cookieValue,
  setCookie,
  referrer,
}: {
  queryParam: string | null;
  cookieValue: string | null;
  setCookie?: (cookieValue: string) => void;
  referrer: string | undefined;
}): Webview => {
  if (referrer && !referrer.includes("realestate.com.au")) {
    return {
      isWebview: false,
    };
  }

  const webviewFromCookieValue = getWebviewFromCookieValue(cookieValue);
  if (
    queryParam === "iphone" ||
    queryParam === "ipad" ||
    queryParam === "android"
  ) {
    setCookie && setCookie(queryParam);
    return { isWebview: true, client: queryParam };
  } else if (queryParam === "outdated_app") {
    if (webviewFromCookieValue) {
      return webviewFromCookieValue;
    } else {
      setCookie && setCookie("outdated_app");
      return { isWebview: true, client: "outdated_app" };
    }
  } else if (webviewFromCookieValue) {
    return webviewFromCookieValue;
  }

  return { isWebview: false };
};
export const createServerWebview = ({
  cookies,
  searchParams,
  referrer,
  setCookie,
}: {
  cookies: CookiesType;
  searchParams: URLSearchParams;
  referrer?: string;
  setCookie: (cookieName: string, cookieValue: string) => void;
}): Webview =>
  createWebview({
    queryParam: searchParams.get("client"),
    cookieValue: cookies[WEBVIEW_COOKIE],
    setCookie: (cookieValue: string) => {
      setCookie(LEGACY_WEBVIEW_COOKIE, cookieValue);
      setCookie(WEBVIEW_COOKIE, cookieValue);
    },
    referrer,
  });

export const createBrowserWebviewAndSetCookie = ({
  cookies = Cookies.get(),
  searchParams = new URLSearchParams(window.location.search),
  referrer = document.referrer,
  setCookie = (client: string) => {
    Cookies.set(LEGACY_WEBVIEW_COOKIE, client);
    Cookies.set(WEBVIEW_COOKIE, client);
  },
}: {
  cookies?: CookiesType;
  searchParams?: URLSearchParams;
  referrer?: string;
  setCookie?: (client: string) => void;
} = {}): Webview =>
  createWebview({
    queryParam: searchParams.get("client"),
    cookieValue: cookies[WEBVIEW_COOKIE],
    setCookie,
    referrer,
  });

export const createBrowserWebview = ({
  cookies = Cookies.get(),
  searchParams = new URLSearchParams(window.location.search),
  referrer = document.referrer,
}: {
  cookies?: CookiesType;
  searchParams?: URLSearchParams;
  referrer?: string;
} = {}): Webview =>
  createWebview({
    queryParam: searchParams.get("client"),
    cookieValue: cookies[WEBVIEW_COOKIE],
    referrer,
  });
